import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g stroke={color} strokeWidth="2" fill="none" fillRule="evenodd">
      <path d="M12 22a3 3 0 0 0 3-3v-1H9v1a3 3 0 0 0 3 3zM12 3c1.1 0 1.991.895 1.991 2h0l.002.356C16.296 6.199 18 8.442 18 11h0v3a2 2 0 1 1 0 4H6a2 2 0 1 1 0-4v-3c0-2.557 1.704-4.8 4.006-5.644L10.009 5c0-1.105.891-2 1.991-2z" />
    </g>
  </svg>
);
